import * as React from "react";
import { TTranslate } from "../../../service/locale/TranslationService";
import { FormComponentProps } from "antd/lib/form";
import FactForm from "./FactForm";

export interface State {}

export interface CreateFactFormProps extends FormComponentProps {
  translate: TTranslate;
  registerFormSubmitEventHandler: any;
  codebooks: { factDataTypes: Array<{ id: string; name: string }> };
}

class CreateFactForm extends React.Component<CreateFactFormProps, State> {
  componentDidMount() {
    const { registerFormSubmitEventHandler } = this.props;
    registerFormSubmitEventHandler(e => {
      e.preventDefault();
      let newData = null;
      this.props.form.validateFields((err, values) => {
        if (!err) {
          newData = values;
        }
      });
      return newData;
    });
  }

  render() {
    const { translate, codebooks } = this.props;

    const { getFieldDecorator } = this.props.form;

    return (
      <FactForm
        codebooks={codebooks}
        translate={translate}
        getFieldDecorator={getFieldDecorator}
      />
    );
  }
}

export default CreateFactForm;
